<template>

<span class="hintergrund" ref="content" no-body>

	    <b-navbar class="mb-4" fixed="top" toggleable="sm">

		<b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
			<b-collapse is-nav id="nav_collapse">

			<b-navbar-nav v-b-scrollspy="200">

						<b-nav-item href="#was">Was</b-nav-item>
						<b-nav-item href="#wer">Wer</b-nav-item>
						<b-nav-item href="#wo">wo</b-nav-item>
						 <!--<b-nav-item id="tooltip-button-show-event" href="#jobs">Jobs</b-nav-item>-->
						<b-nav-item href="#preise">wie teuer</b-nav-item>

			</b-navbar-nav>

                <b-navbar-nav class="ml-auto">
                    <!-- <b-nav-item  @click="showModal" href="#start">anmelden</b-nav-item> -->
					<b-nav-item  @click="openLogin" href="#start">anmelden</b-nav-item>
					

                </b-navbar-nav>
			</b-collapse>
			
	    </b-navbar>

		<div style="height: 41px; width:100%;"></div>

		<div class="kontainer">
			 <div id="start" class="willkommen">
			
			<div class="title mt-4">ArchiAPP</div>
			<div class="subtitle mt-4">mit uns können Sie bauen</div>
				<img class="willkommen" src="/images/hintergrund_q.jpg">
				<div class="subtitlearrow arrow bounce"></div>
			 </div> 
				
		
	<b-card class="anchor ueberschrift my-4 mx-4" id="was" title="Was kann ArchiAPP für Sie machen?">

<div class="erklaerung">
	<p>ArchiPP ist ein Werkzeug, welches Sie von bei vielen Aufgaben unterstützt und damit Arbeit abnimmt. Somit haben Sie mehr Zeit für Ihr Kerngeschäft.</p>
	<p>Es handelt sich um eine Online-Anwendung, die in jedem modernen Internet-Browser läuft. Sie müssen nichts installieren oder auch keine regelmäßigen Updates machen. Sie können mit beliebigen Geräten wie dem normalen Büro-PC, Laptop, Tablet oder Smartphone auf ArchiAPP zugreifen. Die Daten werden im Hintergrund online synchronisiert, sodass Sie immer auf dem aktuellen Stand sind.</p>
	<p>Diese Funktionen stellt ArchiAPP zur Verfügung:</p>


    <b-card
      header-tag="header"
	  class="subCard mb-4"
    >
	  <template v-slot:header>
        <h5 class="mb-0">... für alle</h5>
      </template>

      <b-card-text>
			<b-list-group>
				<b-list-group-item>Adressbuch</b-list-group-item>
				<b-list-group-item>Kalendar</b-list-group-item>
				<b-list-group-item>Online-Kommunikation</b-list-group-item>
				<b-list-group-item>Bildschirm mit anderen teilen</b-list-group-item>
				<b-list-group-item>Videokonferenzen</b-list-group-item>
				<b-list-group-item>Dateien mit anderen teilen</b-list-group-item>
				<b-list-group-item>Rechnungen schreiben</b-list-group-item>
				<b-list-group-item>und mehr...</b-list-group-item>
			</b-list-group>
		  </b-card-text>
    </b-card>
		  
				
				 <b-card
	class="subCard mb-4"
      header-tag="header"
    >
	  <template v-slot:header>
        <h5 class="mb-0">... für Architektur- und Ingenieurbüros</h5>
      </template>

      <b-card-text>
			<b-list-group>
							<b-list-group-item>Honorarberechnung nach HOAI</b-list-group-item>
							<b-list-group-item>Kostenschätzung</b-list-group-item>
							<b-list-group-item>Formulare für Bauanträge / Bauvoranfragen</b-list-group-item>
							<b-list-group-item>Leistungsverzeichnisse</b-list-group-item>
							<b-list-group-item>Ausschreibungen</b-list-group-item>
							<b-list-group-item>Bauablaufplan</b-list-group-item>
							<b-list-group-item>Bautagebuch</b-list-group-item>
							<b-list-group-item>und mehr...</b-list-group-item>
			</b-list-group>
		  </b-card-text>
    </b-card>

    <b-card
      header-tag="header"
	  class="subCard mb-4"
    >
	  <template v-slot:header>
        <h5 class="mb-0">... für Handwerksunternehmen</h5>
      </template>

      <b-card-text>
			<b-list-group>
				<b-list-group-item>Angebote erstellen</b-list-group-item>
				<b-list-group-item>Informationen mit anderen Gewerken austauschen</b-list-group-item>
				<b-list-group-item>und mehr...</b-list-group-item>
			</b-list-group>
		  </b-card-text>
    </b-card>

    <b-card
      header-tag="header"
	  class="subCard mb-4"
    >
	  <template v-slot:header>
        <h5 class="mb-0">... für Bauherren</h5>
      </template>

      <b-card-text>
			<b-list-group>
				<b-list-group-item>mehr Kommunikationsmöglichkeiten mit dem Architekten</b-list-group-item>
				<b-list-group-item>besseres Informationmanagement</b-list-group-item>
				<b-list-group-item>alle wichtigen Unterlagen zum Bau an einem Platz</b-list-group-item>
				<b-list-group-item>und mehr...</b-list-group-item>
			</b-list-group>
		  </b-card-text>
    </b-card>

  </div>
	</b-card>


	<b-card class="anchor ueberschrift my-4 mx-4" id="wer" title="Wer steht hinter ArchiAPP?">
		<div class="erklaerung">
	<p>Das Team hinter ArchiAPP kommt aus der Baubranche (Planung) und aus der Software-Entwicklung. Mit der Kombination des gemeinsamen Wissens, möchten wir die Digitalisierung in der Baubranche voran bringen.</p>
	  </div>
			
	</b-card>
	
	<b-card class="anchor ueberschrift my-4 mx-4" id="wo" title="Wo ist unser Büro?">
		<div class="erklaerung">
	<p>Wir arbeiten flexibel aus dem Homeoffice und haben zusätzlich ein kleines Büro in Köln-Deutz. </p>
	  </div>
				
	</b-card>
	
	<b-card class="anchor ueberschrift my-4 mx-4" id="preise" title="Wie viel müssen Sie für die Nutzung von ArchiAPP bezahlen?">

		<div class="erklaerung">

			<b-card
			header-tag="header"
			class="subCard mb-4"
			>
			<template v-slot:header>
				<h5 class="mb-0">Architektur - und Ingenieurbüros sowie Handwerksunternehmen</h5>
			</template>

			<b-card-text>
					<b-list-group>
						<b-list-group-item>Die Nutzung der Grundfunktionen wie das Adressbuch und Kalender ist kostenlos. 
							Sie bezahlen pro selbst erstelltes Projekt. Der Preis richtet sich nach der Größe* des Projektes. 
							<ul class="mt-2">
								<li>
									<div class="w-50 d-inline-block">kleine Projekte:</div>
									<div class="w-25 d-inline-block text-right"> 10,- Euro</div>
								</li>
								<li>
									<div class="w-50 d-inline-block">mittlere Projekte:</div>
									<div class="w-25 d-inline-block text-right"> 25,- Euro</div>
								</li>
								<li>
									<div class="w-50 d-inline-block">große Projekte:</div>
									<div class="w-25 d-inline-block text-right"> 50,- Euro</div>
								</li>
								<li>
									<div class="w-50 d-inline-block">sehr große Projekte:</div>
									<div class="w-25 d-inline-block text-right"> 100,- Euro</div>
								</li>
							</ul>
						</b-list-group-item>
					</b-list-group>

					<b-button class="mt-2 mb-2" @click="details = !details" pill variant="outline-primary">* Details  <b-icon-caret-down v-if="details"></b-icon-caret-down> <b-icon-caret-up v-if="!details"></b-icon-caret-up></b-button>

					<div v-if="details">

					Die Kategorisierung richtet sich nach der Anzahl der am Projekt beteiligten Büros, Unternehmen, Behörden und andere. Diese Beteiligten können zum Beispiel Auftraggeber, Bauämter, Architekturbüros, Statikbüros, Handwerksbetriebe, etc. sein.
					<br>

					<b-row>
						<b-col cols="3">
							"klein"
						</b-col>
						<b-col cols="2">
							-> bis zu 
						</b-col>
						<b-col class="text-right" cols="4">
							3 Beteiligte
						</b-col>
					</b-row>

					<b-row>
						<b-col cols="3">
							"mittel"
						</b-col>
						<b-col cols="2">
							-> bis zu 
						</b-col>
						<b-col class="text-right" cols="4">
							10 Beteiligte
						</b-col>
					</b-row>

					<b-row>
						<b-col cols="3">
							"groß"
						</b-col>
						<b-col cols="2">
							-> bis zu 
						</b-col>
						<b-col class="text-right" cols="4">
							50 Beteiligte
						</b-col>
					</b-row>

										<b-row>
						<b-col cols="3">
							"sehr groß"
						</b-col>
						<b-col cols="2">
							-> bis zu 
						</b-col>
						<b-col class="text-right" cols="4">
							500 Beteiligte
						</b-col>
					</b-row>


					</div>
				</b-card-text>
			</b-card>

			<!-- <b-card
			class="subCard mb-4"
			header-tag="header"
			>
			<template v-slot:header>
				<h5 class="mb-0"></h5>
			</template>

			<b-card-text>
					<b-list-group>
						<b-list-group-item>kostenlos</b-list-group-item>
					</b-list-group>
				</b-card-text>
			</b-card> -->

			<b-card
			header-tag="header"
			class="subCard mb-4"
			>
			<template v-slot:header>
				<h5 class="mb-0">Bauherren</h5>
			</template>

			<b-card-text>
					<b-list-group>
						<b-list-group-item>kostenlos</b-list-group-item>
						<b-list-group-item>fragen Sie Ihren Architekten nach Ihren Zugangsdaten</b-list-group-item>
					</b-list-group>
				</b-card-text>
			</b-card>

 	</div>
		<p class='addInfo'>Die Preise sind Netto-Preise. Das Angebot richtet sich ausschließlich an Unternehmer im Sinne des § 14 BGB welche in der Baubranche tätig sind.</p>

	</b-card>
	<div style="height:500px;">
	</div>

	</div>


<b-modal ref="my-modal" hide-footer title="Anmelden">
      <div class="d-block text-center">

<iframe width="100%" height="100%" frameborder="0" scrolling="no" allowtransparency="true" src="https://account.archi-app.de/loginExtern"></iframe>

				<!-- <b-form-group
				id="fieldset-1"

				label="Benutzername:"
				label-for="input-1"
				>
				<b-form-input id="input-1" v-model="anmeldedaten.username" trim maxlength="50"></b-form-input>

				</b-form-group>

				<b-form-group
				id="fieldset-1"

				label="Passwort:"
				label-for="input-pw"
				>
				<b-form-input @keyup.enter="login" id="input-pw" type="password" v-model="anmeldedaten.password" trim maxlength="29"></b-form-input>

				</b-form-group>

				<b-row>

					<b-col cols="3" style="min-width:105px;">
						<b-btn :disabled="loadLogin" v-on:click="login">anmelden</b-btn>
					</b-col>

					<b-col>
						<b-spinner v-if="loadLogin" variant="primary" label="Spinning"></b-spinner>					
					</b-col>

				</b-row> -->
			

	

      </div>

    </b-modal>


</span>
</template>

<script>
	import Vue from 'vue'
export default {

 components: {


	},
	
    data(){
        return{
			details:false,
			anmeldedaten:{username:'', password:''},
			registrieren:false,
			 isActive: false,
			 loadLogin:false,
		images: [],
		projectsFull:[],
		projectsThumb:[],
		modalProjekt:{pfad:'', name:''},

        }
	},

	computed:{

	},

	mounted() {

  },

	methods:{

			login: function(){

			this.loadLogin=true;

			this.axios.post('https://account.archi-app.de/api/php/login_script.php', this.anmeldedaten).then((response) => {
			  
			  
			  	if(response.data.login!=true){

					  		this.$bvToast.toast('', {
								title: 'Die Daten sind nicht korrekt. Bitte überprüfen Sie die Eingaben.',
								autoHideDelay: 1000,
							})

					  	this.loadLogin=false;
				  }
				else if(response.data.login===true){

					// this.$bvToast.toast('', {
					// 	title: 'Sie haben sich erfolgreich angemeldet.',
					// 	autoHideDelay: 1000,
					// })

// console.log(response);
				
					var user;
					 if(response.data.user)
					 user = response.data.user;

					 //console.log(user);

					// this.$store.commit('setuserSelbst', response.data.user);

					this.loadLogin=false;

					//this.$root.$emit('logEvent'); //like this
				//	window.location.href = "https://account.archi-app.de/projekte/login";



					// this.$router.push('projekte');
				}
				
			})

			},
	  
	  openLogin(){
window.location.href = "https://account.archi-app.de/login";


	  },
 	showModal() {

		this.$refs['my-modal'].show()
		
      },
	  
      hideModal() {
        this.$refs['my-modal'].hide()
      },
	  
      toggleModal() {
        // We pass the ID of the button that we want to return focus to
        // when the modal has hidden
        this.$refs['my-modal'].toggle('#toggle-btn')
	  },
	  
		scrollFix: function(hashbang)
		{

			location.href = hashbang;

		},
	
	},
	created(){

	}
	
	//
}
</script>

<style>

#footer-copyright {
	padding:5px 0;
	background:#337AB7;
	overflow:hidden;
	font-family:"Open Sans", sans-serif;
	margin: 0 auto;
	position:fixed;
	bottom: 0;
    left: 0;
	width: 100%;
	z-index: 1000;
}

.zentriert {
	text-align:center;

}

.impressum {	
color: #FFF !important;
}
 

.zentriert .router-link-exact-active{
	color: #FFF !important;
}

.zentriert .router-link-active{
	color: #FFF !important;
}

.zentriert a{

	color:#FFF;
	font-size:11px;
	text-transform: uppercase;
}

    .subnav_shadow{
        height:auto;
        width: 100%;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 5%;
        padding-right: 5%;
        left: 0;
        right: 0;
    }

    .subnav{
        position:fixed;
        height:auto;
        width: 100%;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 5%;
        padding-right: 5%;
        border-bottom: 1px solid #6E6E6E;
        background-color: #F2F2F2;
        left: 0;
        right: 0;
        z-index: 880;
    }

    .list-inline_scoped>li {
        display: inline-block;
        padding-left: 5px;
        padding-right: 5px;
        line-height: 15px;
    }

.start-cards{

	min-width: 350px;
	max-width: 650px;
}



.modal-title{
	font-weight: 600 !important;
}

.erklaerung{
text-align:justify;
margin: 0 auto;
max-width:900px;
}

@media (max-width: 830px) {

	.erklaerung{
		width: 80%;
	}
}

@media (max-width: 950px) {
	.erklaerung{
		width: 70%;

	}
}
@media (min-width: 950px) {
	.erklaerung{
		width: 60%;

	}
}

</style>

<style scoped>



.arrow
{
  border: solid white;
  border-width: 0 10px 10px 0;
  display: inline-block;
  padding: 40px;

}


.bounce {
  animation: bounce 3s infinite;
}


@keyframes bounce {


  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0) rotate(45deg);

  }
  40% {
    transform: translateY(-30px) rotate(45deg);

  }
  60% {
    transform: translateY(-15px) rotate(45deg);


  }

}

 .subtitlearrow {

        top: 90%;
		left: 50%;
        position: absolute;


    }

body { 
	background-color: DeepSkyBlue !important; 
}
	.top-left {
		position: absolute;
		top: 8px;
		left: 16px;
		}

	.ueberschrift .card-title
		{

		font-size: 1.5rem;
		text-transform: uppercase;
		font-weight: 700;

		}


.anchor{
	margin-top: 50px !important;
	padding-top: 35px;
}


h4.card-title {
font-size: 1.7rem;
font-weight: 600;

}


.card-img-top
{

	overflow-y: hidden;
}

.card-footer{
	padding: 0rem 0.25rem ;
	position:absolute;
	bottom:0px;
	width:100%;
	z-index: 1000;
	height: 10%;
	font-size:1em;
	font-weight:300;
	overflow-y: hidden;
}

	.card.subCard{

		text-align:justify;

	}



@media (max-width: 830px) {

	.card-footer{
		height: 20%;

	}
}

@media (max-width: 950px) {
	.card-footer{
		height: 15%;

	}
}

.team-card{
max-width: 10rem;
min-width: 5rem;
}

.cryptedmail:after {
  content: attr(data-name) "@" attr(data-domain) "." attr(data-tld); 
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

.buero{
	padding-left: 25px;
	text-align:left;
}

.job{
	padding-left: 20%;
	text-align:left;
}
.navbar_mobile {
  overflow: hidden;
  background-color: #333;  
  position: fixed;
  bottom: 0;

  width: 100%;
  z-index: 10000000;
}

.navbar_mobile a {
  float: left;
  display: block;
  color: #f2f2f2;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 17px;
}

.navbar_mobile a:hover {
  background-color: #ddd;
  color: black;
}

.navbar_mobile a.active {
  background-color: #4CAF50;
  color: white;
}

.navbar_mobile .iconNav {
  display: none;
  width: 60px;
  height: 60px;;
}

@media screen and (max-width: 600px) {

  .navbar_mobile a {display: none;} /*a:not(:first-child) */

  .navbar_mobile a.iconNav {
    float: right;
    display: block;

  }


  .navbar_mobile a.router-link-active {
    float: left;
    display: block;
     background-color:#333 !important;
     color:rgb(139, 215, 245) !important;
  }

}

@media screen and (max-width: 600px) {
  /* .navbar_mobile.responsive_mobile a.router-link-active {display: none;} */
  .navbar_mobile.responsive_mobile .iconNav {
    position: absolute;
    right: 0;
    bottom:0;
        
  }
  .navbar_mobile.responsive_mobile a {
    float: none;
    display: block;
    text-align: left;
  }

}



/* router-link-active */
.router-link-active{
	/* color:#337AB7 !important; */
    /* border-bottom: 1px solid #000; */
}

.router-link-exact-active{
	/* color:#337AB7 !important; */
    /* border-bottom: 1px solid #000; */
}

.router-link-exact-active:hover {
	cursor: default ;
    text-decoration:none;
}


.navbar
{
    padding: 0.5rem 0rem;
    height: 54px;
    background-color:#fff;
}

.navbar-nav{
    margin-left:4.5%;
    margin-right:4.5%;
}

.navbar-nav >  li{
    font-size:1.0em;
    font-weight:400;
	letter-spacing:0.1em;
	color: #000;
	display: block;
	text-transform: uppercase;
	border: 1px solid transparent;
}

a.nav-link.active{
    border-bottom: 11px solid #F2F2F2;
    color: #191970 !important;
}

.clear_bottom a{
    border-bottom: 11px solid transparent;
}

.navbar-collapse{
        background-color:#fff;
}

.navbar-toggler{
        margin-left:4.5%;
}

.navbar-light .navbar-nav .nav-link{
    color:#000;
}

.project-details-liste{
        margin-right:1em;
        padding-right:1.2em;
        border-right: 1px solid #A4A4A4;
}

.hr_line
    {
        border-bottom: 1px solid #A4A4A4;
        margin-left:-10px;
        margin-right:-10px;
        margin-bottom:7px;
    }
    
.projectDetails
    {
        font-weight: 600;
        margin-top: 5px;
        padding-left: 5px;
        padding-top: 5px;
    }
    
.abstandhalter_leer{
       height:54px;
}
    
.subnav_scoped {
	background: #fff;
	padding: 0;
	position: relative;
	text-align: left;
	width: 100%;
	min-height: 35px;
	z-index: 9987;
	border-top: 1px solid #F2F2F2;
}



.leere_zeile{
	height:1em;
}



 .subtitle {

	font-size: 2.0em !important;
	font-weight: 50;
	letter-spacing: 4px;
	color:#000;
	text-shadow: 0.02em 0.02em 0 rgba(0,0,0,0.1);
    line-height: 1.6em;
	
        top: 75px;
        left: 20px;

        position: absolute;
        width: 100%;
        z-index: 999;
        color: #FFFFFF;
        font-size: 0.75em;
        margin-bottom: 50px;

    }

 .title {

	font-size: 3.0em !important;
	font-weight: 50;
	letter-spacing: 4px;
	color:#000;
	text-shadow: 0.02em 0.02em 0 rgba(0,0,0,0.1);
    line-height: 1.6em;
	
        top: 20px;
        left: 20px;

        position: absolute;
        width: 100%;
        z-index: 999;
        color: #FFFFFF;
        font-size: 0.75em;
        margin-bottom: 50px;
    }

@media (max-width: 735px) {

    .title{
    font-size: 2.0em !important;
    }
}

@media (max-width: 600px) {

    .title{
    font-size: 1.5em !important;
    }
}


.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bottom-left {
  position: absolute;
  bottom: 8px;
  left: 16px;
}

.swiper-slide img {
  object-fit: cover;
  
  /* width: 100%;
  min-height: 100%; */
}

.swiper-container{

height:100%;

}

.hintergrund{
	margin-top: 54px;
  height:100%;
}

.kontainer{

  height:100%;
}

.willkommen{
height:100%;
	}

.willkommen img {

  object-fit: cover;
  width: 100%;
  min-height: 100%;

}

#logo {
    width:100%;
    text-align:center;
    margin: 0 auto;
    margin-bottom:60px;
    padding-top:15px;
}


.logo_retz
{
	font-size: 3.0em;
	font-weight: 50;
	letter-spacing: 4px;
	color:#000;
	text-shadow: 0.02em 0.02em 0 rgba(0,0,0,0.1);
    line-height: 1.6em;
}

/* #0 1DF3A*/
/* #E EC7BC*/

.logo_retz_unterschrift
{
	font-size: 1.3em;
	font-weight: 100;
	letter-spacing: 2px;
	color:#9e9e9e;
}

.logo{
    float:right;
    line-height: 53px;
    margin-right:5%;
    font-weight:600;
    font-size:1.2em
}

.logo p{
    margin-right:10px;
}

@media (max-width: 850px) {
    .logo{
    display:none;
    }
}




.welcome
{
	font-size: 1.3em;
	font-weight: 400;
	letter-spacing: 2px;
	color:#000;

}


.welcomeunterschrift
{
	font-size: 1.1em;
	font-weight: 100;
	letter-spacing: 1px;
	color:#3d3d3d;
}
</style>